import { RouteName } from "constant/routeNames";
import { FaPlay } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { addStationToRadio } from "redux/AudioPlayerRedux";
import { Tooltip as ReactTooltip } from "react-tooltip";

function RadioStationCard({ station }: any) {
  const dispatch = useDispatch<any>();
  const handleRadio = () => {
    dispatch(addStationToRadio(station));
  };

  return (
    <div className="flex w-[265px] cursor-pointer items-center gap-3 rounded-lg p-2 transition-colors hover:bg-white/5 max-sm:w-full">
      {/* artwork (click to play) */}
      <div
        onClick={handleRadio}
        className="group relative h-[75px] w-[75px] shrink-0 overflow-hidden rounded-lg ring-1 ring-white/10"
      >
        {station?.artwork_url && (
          <img
            src={station.artwork_url}
            alt="radio station"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
          />
        )}
        {/* hover play overlay */}
        <div className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
          <FaPlay className="text-red-500" />
        </div>
      </div>

      {/* title */}
      <Link
        to={RouteName.RadioDescriptionRoute.replace(":slug", station?.slug)}
        className="group min-w-0 flex-1"
      >
        <p
          className="truncate text-[15px] font-[600] text-white transition-colors group-hover:underline"
          data-tooltip-id={station?.slug}
        >
          {station.title.length > 15
            ? `${station.title.slice(0, 15)}...`
            : station.title}
        </p>
        {station.title.length > 15 && (
          <div className="z-50 text-sm">
            <ReactTooltip
              id={station?.slug}
              content={station.title}
              place="top"
            />
          </div>
        )}
      </Link>
    </div>
  );
}

export default RadioStationCard;